import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function LaunchPrice() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'hs'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'seg'
  }];
  return <section aria-label="Precio de lanzamiento" className="border-b border-ink-700 bg-ink-950 py-16 sm:py-20" data-id="element-105" data-mp="2d23la7j4g8z">
      <div className="mx-auto w-full max-w-page px-5 text-center sm:px-8" data-id="element-106" data-mp="z3kvmpszab7p">
        <p className="text-[11px] font-bold uppercase tracking-[0.28em] text-ash" data-id="element-107" data-mp="u3falsh7rmyl">
          ⏰ Precio de lanzamiento
        </p>

        <div className="mt-7 flex items-end justify-center gap-3 sm:gap-5" data-id="element-108" data-mp="laboywwf03sv">
          {units.map(unit => <div key={unit.label} className="min-w-[86px] border border-ink-700 bg-ink-900 px-4 py-5 sm:min-w-[120px]" data-id="element-109" data-mp="1hrzlvavh1l7g">
              <p className="display tabular text-4xl text-bone sm:text-6xl" data-id="element-110" data-mp="1d0849puamptg">{unit.value}</p>
              <p className="mt-1 text-[10px] font-bold uppercase tracking-[0.22em] text-ash" data-id="element-111" data-mp="1kr8zdu8bpdv1">
                {unit.label}
              </p>
            </div>)}
        </div>

        <p className="mt-7 inline-flex items-center gap-2 border border-alert/50 bg-alert/10 px-4 py-2 text-sm font-semibold text-bone" data-id="element-112" data-mp="1azw8b4ucmrq2">
          <AlertTriangleIcon className="h-4 w-4 text-alert" aria-hidden="true" data-id="element-113" data-mp="1fxe7w4mh7ule" />
          Después sube $6.000 ARS. No vuelve.
        </p>

        <div className="mx-auto mt-10 max-w-md" data-id="element-114" data-mp="16zc97vq7te1a">
          <div className="flex items-center justify-between text-xs font-bold uppercase tracking-[0.18em] text-ash" data-id="element-115" data-mp="16wzk8ym1i3eq">
            <span className="text-alert" data-id="element-116" data-mp="x0wk1yar0euf">🔴 68% de los cupos ya tomados</span>
            <span data-id="element-117" data-mp="x2z6k8cozpue">68%</span>
          </div>
          <div className="mt-3 h-2 w-full border border-ink-700 bg-ink-900" role="progressbar" aria-valuenow={68} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos tomados" data-id="element-118" data-mp="2mfb5o9qgzllp">
            <div className="h-full bg-alert" style={{
            width: '68%'
          }} data-id="element-119" data-mp="2pvdxw0abs8pi" />
          </div>
        </div>
      </div>
    </section>;
}